import { DEV } from "solid-js"
import type { Color } from "three"
import type { Nullable } from "../../../../typescript"
import getTileGraphNodeLayer1Entity from "../../../core/engine/TileGraphNode/getTileGraphNodeLayer1Entity"
import type { TileGraphNode } from "../../../core/engine/TileGraphNode/TileGraphNode.type"
import Unexpected from "../../../Exception/Unexpected.class"
import getTerrainMesh1V2TileColor from "./getTerrainMesh1V2TileColor"

/**
 * Colors for the 8 neighbours in the same order as eightDirections.
 * `base` is the color of the centre tile.
 */
export type NeighborColorCollection = {
  base: Color
  list: Array<Color>  // length === 8
}

/**
 * Weighted interpolation of color at an arbitrary point inside a tile.
 *
 * @param weights   WeightsV2 from calculateNeighborWeights
 * @param elev      ColorsV2 for base + 8 neighbours
 * @returns         The interpolated color
 */
export default function createNodeNeighborBaseColorCollection(
  node: TileGraphNode,
  eightNeighbors: Array<Nullable<TileGraphNode>>,
): NeighborColorCollection {

  if (DEV) {
    if (eightNeighbors.length !== 8) {
      throw new Unexpected('eightNeighbors.length !== 8')
    }
  }

  const base = getTerrainMesh1V2TileColor(getTileGraphNodeLayer1Entity(node))
  return {
    base,
    list: eightNeighbors.map(node1 => {
      const ent = getTileGraphNodeLayer1Entity(node1)
      const color = getTerrainMesh1V2TileColor(ent)
      return color
    }),
  }
}
